import styled, { css } from 'styled-components'
import type { ReactNode, FunctionComponent } from 'react'

const StyledLi = styled.li<{ type?: string }>`
  display: flex;
  margin-bottom: 1rem;
  cursor: pointer;

  button {
    display: flex;
    background-color: var(--light);
    flex-direction: row;
    align-items: center;
    line-height: 1.5rem;
  }

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 2px;
    color: var(--dark);
  }

  ${({ type }) =>
    type === 'share' &&
    css`
      button {
        color: var(--blue);
      }
      &:hover {
        text-decoration: underline;
        text-underline-offset: 3px;
        text-decoration-thickness: 2px;
        color: var(--blue);
      }
      &:last-of-type {
        margin-bottom: 0;
      }
    `}
`

interface MenuButtonProps {
  handleClick: () => void
  type?: string
  children: ReactNode
}

export const MenuButton: FunctionComponent<MenuButtonProps> = ({ children, handleClick, type }) => {
  return (
    <StyledLi type={type}>
      <button type="button" onClick={handleClick}>
        {children}
      </button>
    </StyledLi>
  )
}

export const Menu = styled.div`
  position: absolute;
  z-index: 999;
  background-color: var(--light);
  border: 2px solid var(--blue);
  color: var(--blue);
  max-height: calc(100% - 9.5rem);
  max-width: min(37em, calc(100% - 6rem));
  overflow: auto;
  bottom: 4.5rem;

  svg {
    fill: var(--blue);
    margin-right: 1rem;
    height: 1.5rem;
    width: 1.5rem;
  }

  h5 {
    color: var(--blue);
  }
  &.topo {
    left: 1rem;
    padding: 1rem 1.5rem;
  }
  &.share {
    left: 4.3rem;
    padding: 0.5rem;

    @media screen and (min-width: 768px) {
      left: 13.1rem;
    }
  }
`
